import React, { useEffect, useState } from 'react';
import * as S from './styles';
import { Tabs, TabPanel } from 'react-tabs';
import useBuscaClientes from '../../services/Cliente/useBuscaClientes';
import useBuscaEstabelecimento from '../../services/Estabelecimento/useBuscaEstabelecimento';
import BuscaProduto from '../../services/Produto/BuscaProdutoCliente';
import AtendimentoBaseServices from '../../services/AtendimentoBase/AtendimentoBaseServices';
import secureStorage from '../../utils/SecureStorage';
import ModalSelecionarProduto from '../ModalSelecionarProduto';

const getInicialForm = () => ({
  estabelecimento: null,
  clientes: [],
});

const ModalCadastroAtendimento = ({ isOpen, onClose, atendimentoSelecionado, atualizarLista }) => {
  const [form, setForm] = useState(getInicialForm());
  const [tabIndex, setTabIndex] = useState(0);
  const [produtosClienteIndex, setProdutosClienteIndex] = useState(null);
  const [produtos, setProdutos] = useState([]);
  const [clienteAbertoId, setClienteAbertoId] = useState(null);
  const [loading, setLoading] = useState(false);

  const { searchResults: clientes, loadregistros: loadClientes } = useBuscaClientes();
  const { searchResults: estabelecimentos, loadregistros: loadEstabelecimentos } = useBuscaEstabelecimento();
  const { loadprodutos } = BuscaProduto();

  useEffect(() => {
    if (isOpen) {
      const idRede = secureStorage.getItem('id_r');
      if (idRede) {
        loadClientes(idRede);
        loadEstabelecimentos(idRede);
      }

      if (atendimentoSelecionado) {
        setForm({
          ...atendimentoSelecionado,
          estabelecimento: {
            ...atendimentoSelecionado.estabelecimento,
            id: atendimentoSelecionado.estabelecimento.id || atendimentoSelecionado.estabelecimento._id?.$oid || atendimentoSelecionado.estabelecimento._id
          },
          _id: atendimentoSelecionado._id?.$oid || atendimentoSelecionado._id || null
        });
      } else {
        setForm(getInicialForm());
      }

      setTabIndex(0);
      setProdutos([]);
      setProdutosClienteIndex(null);
      setClienteAbertoId(null);
    }
  }, [isOpen, atendimentoSelecionado]);

  const toggleClienteProdutos = (clienteId) => {
    setClienteAbertoId(prev => (prev === clienteId ? null : clienteId));
  };

  const handleEstabelecimentoChange = (e) => {
    const est = estabelecimentos.find(est => est._id.$oid === e.target.value);
    setForm(prev => ({ ...prev, estabelecimento: est }));
  };

  const handleAddCliente = (id) => {
    const cliente = clientes.find(c => c._id.$oid === id);
    if (!form.clientes.find(c => c.cliente._id === id)) {
      setForm(prev => ({
        ...prev,
        clientes: [...prev.clientes, { cliente, produtos: [] }]
      }));
    }
  };

  const handleRemoveCliente = (id) => {
    setForm(prev => ({
      ...prev,
      clientes: prev.clientes.filter(c => c.cliente._id !== id)
    }));
    if (clienteAbertoId === id) {
      setClienteAbertoId(null);
    }
  };

  const handleOpenProdutos = async (index) => {
    const cliente = form.clientes[index].cliente;
    const idRede = secureStorage.getItem('id_r');
    const idCliente = cliente._id?.$oid || cliente._id;

    if (idRede && idCliente) {
      const produtosCarregados = await loadprodutos(idRede, idCliente);
      const produtosMapeados = (produtosCarregados || []).map(p => ({
        _id: p._id?.$oid || p._id,
        gtin: p.gtin || '-',
        marca: p.brand?.name || '-',
        descricao: p.description || '-',
        thumbnail: p.thumbnail || null
      }));
      setProdutos(produtosMapeados);
      setProdutosClienteIndex(index);
    }
  };

  const handleConfirmProdutos = (produtosSelecionados) => {
    setForm(prev => {
      const clientes = [...prev.clientes];
      const clienteAtual = clientes[produtosClienteIndex];
      const produtosExistentesIds = new Set(clienteAtual.produtos.map(p => p._id));
      const produtosNovos = produtosSelecionados.filter(p => !produtosExistentesIds.has(p._id));
      clienteAtual.produtos = [...clienteAtual.produtos, ...produtosNovos];
      return { ...prev, clientes };
    });
    setProdutosClienteIndex(null);
    setProdutos([]);
  };

  const handleRemoveProduto = (clienteIdx, produtoIdx) => {
    setForm(prev => {
      const clientes = [...prev.clientes];
      clientes[clienteIdx].produtos.splice(produtoIdx, 1);
      return { ...prev, clientes };
    });
  };

  const handleUsarComoBase = () => {
    setForm(prev => ({
      ...prev,
      _id: null
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        _id: form._id?.$oid || form._id,
        estabelecimento: {
          id: form.estabelecimento.id || form.estabelecimento._id?.$oid || form.estabelecimento._id,
          nome_fantasia: form.estabelecimento.nome_fantasia,
          Razao_Social: form.estabelecimento.Razao_Social,
          cpf_cnpj: form.estabelecimento.cpf_cnpj,
          contato: form.estabelecimento.contato || {},
          endereco: form.estabelecimento.endereco || {}
        },
        clientes: form.clientes.map(c => ({
          id: c.cliente._id?.$oid || c.cliente._id,
          nome: c.cliente.nome,
          cpf_cnpj: c.cliente.cpf_cnpj,
          endereco: c.cliente.endereco || {},
          contato: c.cliente.contato || {},
          observacoes: c.cliente.observacoes || '',
          produtos: (c.produtos || []).map(p => ({
            id: p._id,
            gtin: p.gtin,
            descricao: p.descricao,
            marca: p.marca,
            thumbnail: p.thumbnail || ''
          }))
        }))
      };

      if (!payload.estabelecimento.id || payload.clientes.length === 0) {
        alert('Preencha todos os campos obrigatórios antes de salvar.');
        return;
      }

      if (form._id) {
        await AtendimentoBaseServices.updateVisita(payload);
      } else {
        await AtendimentoBaseServices.createVisita(payload);
      }

      atualizarLista();
      onClose();
    } catch (err) {
      console.error('Erro ao salvar atendimento:', err);
      alert("Erro ao salvar o cadastro. Por favor, verifique os logs para mais detalhes.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <S.Overlay>
      <S.ModalContainer>
        <S.Title>{form._id ? 'Editar Atendimento' : 'Novo Atendimento'}</S.Title>

        <Tabs selectedIndex={tabIndex} onSelect={setTabIndex}>
          <S.StyledTabList>
            <S.StyledTab>Estabelecimento</S.StyledTab>
            <S.StyledTab>Produto/Cliente</S.StyledTab>
          </S.StyledTabList>

          <TabPanel>
            <S.InputGroup>
              <S.Label>Estabelecimento</S.Label>
              <S.Select value={form.estabelecimento?._id?.$oid || ''} onChange={handleEstabelecimentoChange}>
                <option value=''>Selecione</option>
                {estabelecimentos.map(est => (
                  <option key={est._id.$oid} value={est._id.$oid}>{est.nome_fantasia}</option>
                ))}
              </S.Select>
            </S.InputGroup>

            {form.estabelecimento && (
              <div style={{
                marginTop: '16px',
                padding: '16px',
                backgroundColor: '#f2f2f2',
                borderRadius: '10px',
                fontSize: '14px',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '12px'
              }}>
                <div>
                  <p><strong>Nome Fantasia:</strong> {form.estabelecimento.nome_fantasia}</p>
                  <p><strong>Razão Social:</strong> {form.estabelecimento.Razao_Social}</p>
                  <p><strong>CPF/CNPJ:</strong> {form.estabelecimento.cpf_cnpj}</p>
                  <p><strong>CEP:</strong> {form.estabelecimento.endereco?.cep || 'Não informado'}</p>
                </div>
                <div>
                  <p><strong>Endereço:</strong> {form.estabelecimento.endereco?.rua}, Nº {form.estabelecimento.endereco?.numero}</p>
                  <p><strong>Bairro:</strong> {form.estabelecimento.endereco?.bairro}</p>
                  <p><strong>Cidade/UF:</strong> {form.estabelecimento.endereco?.cidade} - {form.estabelecimento.endereco?.estado}</p>
                </div>
                <div>
                  <p><strong>Telefone Fixo:</strong> {form.estabelecimento.contato?.telefone_fixo || 'Não informado'}</p>
                  <p><strong>Celular:</strong> {form.estabelecimento.contato?.celular || 'Não informado'}</p>
                  <p><strong>WhatsApp:</strong> {form.estabelecimento.contato?.WhatsApp || 'Não informado'}</p>
                </div>
              </div>
            )}

          </TabPanel>

          <TabPanel>
            <S.InputGroup>
              <S.Label>Adicionar Cliente</S.Label>
              <S.Select onChange={(e) => handleAddCliente(e.target.value)}>
                <option value=''>Selecione</option>
                {clientes.map(cli => (
                  <option key={cli._id.$oid} value={cli._id.$oid}>{cli.nome}</option>
                ))}
              </S.Select>
            </S.InputGroup>

            {form.clientes.map((cliData, idx) => (
              <S.ClienteBox key={cliData.cliente._id || idx}>
                <strong
                  style={{ cursor: 'pointer', display: 'inline-block', marginBottom: '6px' }}
                  onClick={() => toggleClienteProdutos(cliData.cliente._id)}
                >
                  {cliData.cliente.nome} {cliData.produtos.length > 0 && <span style={{ color: 'green' }}>({cliData.produtos.length} produto{cliData.produtos.length > 1 ? 's' : ''})</span>}
                </strong>
                <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                  <S.SmallButton onClick={() => handleRemoveCliente(cliData.cliente._id)}>Remover</S.SmallButton>
                  <S.SmallButton onClick={() => handleOpenProdutos(idx)}>Selecionar Produtos</S.SmallButton>
                </div>

                {clienteAbertoId === cliData.cliente._id && cliData.produtos?.length > 0 && (
                  <S.StyledTable>
                    <thead>
                      <tr>
                        <th>GTIN</th>
                        <th>Marca</th>
                        <th>Descrição</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cliData.produtos.map((produto, pidx) => (
                        <tr key={produto._id || pidx}>
                          <td>{produto.gtin}</td>
                          <td>{produto.marca}</td>
                          <td>{produto.descricao}</td>
                          <td>
                            <S.SmallButton onClick={() => handleRemoveProduto(idx, pidx)}>X</S.SmallButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </S.StyledTable>
                )}
              </S.ClienteBox>
            ))}
          </TabPanel>
        </Tabs>

        <S.ButtonGroup>
          <S.Button onClick={handleUsarComoBase}>Usar como Base</S.Button>
          <S.Button onClick={handleSubmit} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</S.Button>
          <S.CancelButton onClick={onClose}>Cancelar</S.CancelButton>
        </S.ButtonGroup>

        <ModalSelecionarProduto
          isOpen={produtosClienteIndex !== null}
          onClose={() => {
            setProdutosClienteIndex(null);
            setProdutos([]);
          }}
          produtos={produtos}
          onSelecionar={handleConfirmProdutos}
        />
      </S.ModalContainer>
    </S.Overlay>
  );
};

export default ModalCadastroAtendimento;
